import React from "react";
import classes from './LearningLesson.module.css'
import StorylinePlayer from "./StorylinePlayer";
import SLCPlayer from "./SLCPlayer";
import { useSelector } from "react-redux";
import Loader from '../../../UI/Loader/Loader';

const LearningLesson = ({ lessonParticipant, materialContentPath, openProject, materialContentType, id, name, studyGroupId, onlyView, loader, jumpToQuestion, assessment, scoreByRetries, assessmentLearningCount, finalAssessment }) => {

    const texts = useSelector(state => state.translate.texts);
    const user = useSelector((state) => state.auth.user);
    const lessonContentTypesEnum = {
        Storyline: StorylinePlayer,
        SLC: SLCPlayer
    }

    return (
        <div className={classes.LearningContainer}>
            {loader ? <Loader /> :
                materialContentPath && materialContentType && materialContentType !== "Pdf" ? (() => {
                    const Compnent = lessonContentTypesEnum[materialContentType];
                    if (Compnent) {
                        return <Compnent
                        allUserIds={lessonParticipant?.user?.users?.map(u => u.id !== user.id ? u.id : null).filter(Boolean)}
                            studyGroupId={studyGroupId}
                            lessonId={id}
                            lessonName={name}
                            finalAssessment={finalAssessment}
                            assessmentLearningCount={assessmentLearningCount}
                            contentDirPath={`${materialContentPath}/`}
                            openProject={openProject}
                            onlyView={onlyView}
                            jumpToQuestion={jumpToQuestion}
                            assessment={assessment}
                            scoreByRetries={scoreByRetries}
                        />
                    }
                })() : <div className={classes.NoLessons}>{texts.noLessons}</div>}

            {/* { materialContentPath && <StorylinePlayer openProject={openProject} baseDirPath={materialContentPath} ></StorylinePlayer>} */}
        </div>
    )
}

export default LearningLesson;